import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DateToStringPipe } from './date-to-string.pipe';
import { ToUpperTrimPipe } from './to-upper-trim.pipe';
import { CustomDateFormatterPipe } from './customDateFormatterPipe';
import { PatientProfileImagePipe } from './patient-profile-image.pipe';
import { CustomHourHHmmFormatterPipe } from './customHourHHmmFormatterPipe';

@NgModule({
  declarations: [
    DateToStringPipe,
    ToUpperTrimPipe,
    CustomDateFormatterPipe,
    PatientProfileImagePipe,
    CustomHourHHmmFormatterPipe
  ],
  imports: [
    CommonModule
  ],
  exports:
    [
      DateToStringPipe,
      ToUpperTrimPipe,
      CustomDateFormatterPipe,
      PatientProfileImagePipe,
      CustomHourHHmmFormatterPipe
    ]
})
export class ApplicationPipesModule { }
